import { AfterViewInit, Component, Input, NgZone, ViewChild } from '@angular/core';

import { AutocompleteExtraLink } from 'SearchApp/ts/types/categories-autocomplete-results.type';
import { AutocompleteResult } from 'SearchApp/ts/interfaces/autocomplete-result.interface';

import { BaseAutocompleteComponent } from 'SearchApp/ts/features/base-autocomplete/components/base-autocomplete.component';

/**
 *
 * Top Bar Nav Autocomplete Component
 *   Input defaultResults: list of AutocompleteExtraLink items to display when autocompleter is focused but empty
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-top-bar-nav-autocomplete',
    templateUrl: './top-bar-nav-autocomplete.template.html',
})
export class TopBarNavAutocompleteComponent implements AfterViewInit {
    @ViewChild(BaseAutocompleteComponent) baseAutocompleter?: BaseAutocompleteComponent;

    @Input() defaultResults: AutocompleteExtraLink[] = [];

    readonly BLURRED_PLACEHOLDER: string = 'Enter text or press “/”';

    searchPlaceholder: string = this.BLURRED_PLACEHOLDER;

    constructor(private ngZone: NgZone) {}

    selectResult(result: AutocompleteResult | AutocompleteExtraLink): void {
        if ((result as AutocompleteExtraLink).newTab) {
            window.open(result.url, '_blank');
        } else {
            window.location.href = result.url;
        }
    }

    reset(): void {
        if (this.baseAutocompleter) {
            this.baseAutocompleter.reset();
        }
    }

    ngAfterViewInit(): void {
        this.ngZone.runOutsideAngular(() => {
            // Focus search input when the slash key is pressed
            document.addEventListener('keydown', (event: KeyboardEvent) => {
                // Ignore other keys
                if (event.key !== '/') {
                    return;
                }

                // Make sure a text input is not currently focused
                const activeElement = document.activeElement as Element & { type: string };
                const focusedElementIsTextInput: boolean =
                    activeElement &&
                    ((activeElement.tagName === 'INPUT' && activeElement.type === 'text') ||
                        activeElement.tagName === 'TEXTAREA' ||
                        activeElement.classList?.contains('ql-editor'));
                if (focusedElementIsTextInput) {
                    return;
                }

                // Make sure no modals are open
                const modalOpen: boolean = !!document.querySelector('.modal-backdrop.show');
                if (modalOpen) {
                    return;
                }

                event.preventDefault();
                if (this.baseAutocompleter) {
                    this.baseAutocompleter.focus();
                }
            });
        });
    }
}
